import Modal from '../Modal';
import { useEffect, useState } from 'react';
import TextInput from '../TextInput';
import ErrorMessage from '../ErrorMessage';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import { setEventTypesQuery } from '../../lib/Queries';

const UpdateEventTypeCategoryModal = ({ isOpen, onClose, category }) => {
    const [name, setName] = useState('');
    const [nameError, setNameError] = useState();
    const { save, isSaving } = useBusinessPostApi(
        `/event-types/category/${category?.id || 0}`,
    );

    const isNew = !category?.id;

    useEffect(() => {
        if (isOpen) {
            setName(category?.name || '');
        }
    }, [isOpen]);

    function onSubmit(e) {
        e.preventDefault();

        if (!name.trim()) {
            setNameError('Category name is required');
            return;
        }
        setNameError('');

        save({ name }).then(result => {
            setEventTypesQuery(result, true);
            onClose();
        });

        onClose();
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <form onSubmit={onSubmit}>
                <h2>{isNew ? 'Add Category' : 'Edit Category'}</h2>
                <TextInput
                    value={name}
                    onChange={setName}
                    label="Name"
                    required={true}
                    autoFocus={true}
                />
                {!!nameError && <ErrorMessage>{nameError}</ErrorMessage>}

                <button type="submit" className="btn-save mt-4">
                    {isSaving ? 'Saving...' : 'Save'}
                </button>
            </form>
        </Modal>
    );
};

export default UpdateEventTypeCategoryModal;
